import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';

class Contact extends Component {
  render() {
    return (
      <DocumentMeta title="Kontakt os - SparPenge.dk" extend>
        <h3>Kontakt</h3>
        <p>
          Inden du kontakter os, så husk, at SparPenge.dk er en gratis
          prissammenligningstjeneste. Vores service er at hjælpe dig med at
          spare penge ved at give dig det fulde overblik over udbydere af lån,
          A-kasser, bredbånd, mobilabonnementer, tv-pakker og taletidskort.
          SparPenge.dk sælger altså ikke nogen produkter. Eventuelle spørgsmål
          til de enkelte produkter, bør derfor rettes direkte til den enkelte
          udbyder. Kontaktoplysningerne finder du på udbyderes hjemmeside, som
          du kan klikke dig ind på under det enkelte produkt, som du har
          spørgsmål til.
        </p>
        <p>
          Hvis du oplever problemer med SparPenge.dk eller har spørgsmål, som
          ikke vedrører produkterne, så er du selvfølgelig meget velkommen til
          at kontakte os via e-mail på:{' '}
          <a href="mailto:kontakt@sparpenge.dk" target="_blank">
            kontakt@sparpenge.dk
          </a>
        </p>
      </DocumentMeta>
    );
  }
}

export default Contact;
